import { defineMessages } from "react-intl";

/** Fixed UI strings of the Builder product tile / Featured Product Slider card (merchandiser copy comes in through Builder inputs). */
const messages = defineMessages({
  greatFor: {
    id: "productTile.feature.great_for",
    defaultMessage: "Great for",
  },
  keyBenefits: {
    id: "productTile.feature.key_benefits",
    defaultMessage: "Key benefits",
  },
  quickView: {
    id: "productTile.feature.quick_view",
    defaultMessage: "Quick view",
  },
  noImage: {
    id: "productTile.feature.no_image",
    defaultMessage: "No image",
  },
});

export default messages;
